export default __webpack_public_path__ + "static/media/element_76.91992377.jpg";